var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAppFolderCogOutlined = function SvgAppFolderCogOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#app-folder-cog-outlined_svg__app-folder-cog-outlined_svg__clip0_7867_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.52 16.354H4.27a1.667 1.667 0 01-1.666-1.667V5.52A1.667 1.667 0 014.27 3.854h3.334l2.5 2.5h5.833a1.667 1.667 0 011.667 1.666v2.5m-1.666 7.5a1.667 1.667 0 010-3.333m0 3.333a1.667 1.667 0 000-3.333m0 3.333v1.25m0-4.583v-1.25m2.525 1.458l-1.082.625m-2.886 1.667l-1.083.625m0-2.917l1.083.625m2.886 1.667l1.083.625",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "app-folder-cog-outlined_svg__app-folder-cog-outlined_svg__clip0_7867_426"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.104 .52)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAppFolderCogOutlined;